module.exports = __webpack_public_path__ + "static/img/logo1.f73732a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.png
// module id = 182
// module chunks = 1